import { AxiosInstance } from 'axios'

import loqateApi from '@mindfulchefuk/services/loqate/api'

const EmailValidationInteractive = (): AxiosInstance => {
  const { originURL } = loqateApi.defaults
  loqateApi.defaults.baseURL = `${originURL}/EmailValidation/Interactive`
  return loqateApi
}

export default EmailValidationInteractive
